import i18n from "i18n";

import { Feature, SearchTagWithSource } from "redux/services/config";

import { parseLanguageObject } from "utils/parseLanguageObject";

import { useQueryParams } from "./useQueryParams";

interface Props {
  combinedSearchTags: SearchTagWithSource[] | undefined;
  handleShowSearchResults: (
    tagName: string,
    features: Feature[],
    options?: { useSearchResultsCarousel: boolean },
  ) => void;
  callback: () => void;
}

export const useHandleQsSearchTagLoad = ({
  combinedSearchTags,
  handleShowSearchResults,
  callback,
}: Props) => {
  const { qsSearchTagId, qsSearchTagType, queryParams } = useQueryParams();

  const handleQsSearchTagLoad = () => {
    // If both qsSearchTagId and qsSearchTagType are present in the URL, we need to display the search tag results
    if (qsSearchTagId && qsSearchTagType) {
      // Find search tag within the combined search tags array
      const searchTag = combinedSearchTags?.find(
        (tag) =>
          tag.id === Number(qsSearchTagId) && tag.source === qsSearchTagType,
      );

      if (searchTag) {
        handleShowSearchResults(
          parseLanguageObject(searchTag.name, i18n.language) || "",
          searchTag.features,
          { useSearchResultsCarousel: true },
        );
      } else
        console.warn(
          `Search tag with ID ${qsSearchTagId} and type ${qsSearchTagType} not found`,
        );

      // Remove the qsSearchTagId and qsSearchTagType query params from the URL after the search tag features has been loaded
      queryParams.delete("search_tag_id");
      queryParams.delete("search_tag_type");
      const newUrl = `${new URL(window.location.href).pathname}?${queryParams.toString()}`;
      window.history.replaceState({}, "", newUrl);

      callback();
    }
  };

  return {
    handleQsSearchTagLoad,
  };
};
